module.exports = __webpack_public_path__ + "static/media/sewing.a1313e1b.jpg";